<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kIYoIK/tc-custom/Cover.jpg?1684306037520?1706907374766" alt="This image is the cover for the book Moonlight Mill Murders of Steubenville, Ohio"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moonlight Mill Murders of Steubenville, Ohio
      </h1>
      <p class="bookDescription body article font2">
        <b>“Guy is not only a historian but a longtime police officer in Ohio, bringing firsthand knowledge of the criminal justice system” to the Phantom Killer tale (<i>Crime Capsule</i>).</b><br/>  <br/> Prohibition ended on December 5, 1933, and Steubenville hoped that its reputation as “Little Chicago” would end with it. That hope was short-lived when, eight weeks later, the Phantom Killer made his midnight debut. Under the glow of a full moon, in the mill yards of Steubenville’s Wheeling Steel Plant, the killer ambushed a rail worker, shooting him five times. The Steubenville Police Department, Jefferson County Sheriff’s Department and Wheeling Steel Mill Police joined forces in the New Year to find the Phantom before he took another victim. The strongest of millworkers on the midnight shift began to arm themselves, wondering who would be next. As the investigation wore on, Steubenville was once again thrust into the national spotlight as the Phantom’s reign of terror continued. Local historian Susan M. Guy delves into one of the city’s most infamous crimes.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan M Guy
      </h2>
      
      <p class="authorDescription body article">Susan M. Guy was born and raised in Jefferson County, Ohio. The daughter of a police captain, Susan followed in his law enforcement footsteps. She was a police officer for fifteen years on the Cross Creek Township Police Department, achieving the rank of sergeant. She is currently a corrections officer for the State of Ohio, with more than twenty-five years of service. She is a member of the Tri State Writers Society, a local writers' group, where she serves as the group's public relations director. Her debut book, Mobsters, Madams & Murder in Steubenville, Ohio, published by The History Press in 2014, was greatly received. The Moonlight Mill Murders of Steubenville, Ohio promises to be a thrilling follow-up.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8e16d96e